<template>
   <!-- @ts-ignore -->
  <v-tooltip
    :content-class="`tooltip black px-4 py-3 ${$attrs['content-class']}`"
    :top="$attrs.right === undefined"
    :bottom="$attrs.bottom"
    right
    transition="scroll-y-transition"
    v-bind="$attrs"
  >
    <template #activator="{ props }">
      <slot name="activator" v-bind="props" />
    </template>
    <span
      :class="`body-2 ${maxHeight ? 'hide-overflow' : ''}`"
      :style="{ maxHeight: `${maxHeight}px` }"
    >
      <slot>{{ $attrs['tooltip-content'] }}</slot>
    </span>
  </v-tooltip>
</template>
<script setup lang="ts">
import { defineProps } from 'vue'

defineProps<{
  maxHeight?: number
}>()
</script>
<style scoped lang="scss">
.v-icon {
  margin-bottom: 2px;
}
.tooltip {
  border-radius: 0;
  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    right: calc(50% - 4px);
    width: 10px;
    border-top: 8px solid transparent;
    border-right: 8px solid var(--v-black-base);
    transform: rotate(45deg) translateY(50%);
  }
  &.bottom::before {
    bottom: unset;
    top: 0;
    border-top: unset;
    border-bottom: 8px solid transparent;
    transform: rotate(-45deg) translateY(-50%);
  }
  &.right::before {
    bottom: 50%;
    left: 0;
    right: unset;
    transform: rotate(135deg) translateX(50%);
  }
  &.no-arrow::before {
    display: none;
  }
}
.hide-overflow {
  white-space: wrap;
  display: flex;
  overflow: hidden;
  align-items: flex-start;
}
</style>
